import { DialogSlideRight } from "../../Dialogs/SlideInRightDialog";
import { Group } from "../../../interfaces/topicInterfaces";
import { useEffect, useState } from "react";
import { fetchTopics } from "../../../firebase/firebaseExamService";
import { SelectingObjectivesTable } from "../SelectingObjectivesTable";
import { SelectObjectivesAccordion } from "../SelectObjetivesAccordion";
import { CircularProgress, Stack } from "@mui/material";
import { Grade } from "../../../types/App";
import LoupeIcon from "@mui/icons-material/Loupe";
import { updateObjectives } from "../Functions/FunctionsChangeObjectives";
import { useSelector } from "react-redux";
import { RootState } from "../../..";
import { overwriteObjectives } from "../Functions/FunctionsMain";
import { cloneDeep } from "lodash";
import { useLocation } from "react-router-dom";
import { DEMO_TOPIC_DATA } from "../DemoData";

const SelectObjectivesExamDialog = ({
  open,
  grade,
  handleCancel,
}: {
  open: boolean;
  grade: Grade;
  handleCancel: () => void;
}) => {
  const [dataTopics, setDataTopics] = useState<Group[] | null>(null);
  const examData = useSelector((state: RootState) => state.examBuilder.main.examData);
  const objectivesCopy = useSelector((state: RootState) => state.examBuilder.main.objectivesCopy);
  const selectTopicsExamDialog = useSelector((state: RootState) => state.dialogs.selectTopicsExamDialog);

  const { pathname } = useLocation();
  const isDemoMode: boolean = pathname.startsWith("/demo");

  //Fetch the topics
  useEffect(() => {
    if (isDemoMode) {
      getDemoData();
    } else {
      fetchAndSetTopics();
    }
  }, []);

  //Copies the objectives when the dialog opens
  useEffect(() => {
    overwriteObjectives(cloneDeep(examData.objectives));
  }, [selectTopicsExamDialog]);

  const handleUpdateObjectives = () => {
    updateObjectives(objectivesCopy, examData);
  };

  const fetchAndSetTopics = async () => {
    try {
      const fetchedData = await fetchTopics({ grade });
      if (fetchedData) {
        const innerArray = fetchedData.groups;
        setDataTopics(innerArray);        
      }
    } catch (error) {
      console.error("Error fetching topics:", error);
    }
  };

  const getDemoData = () => {
    setDataTopics(DEMO_TOPIC_DATA);
  };

  return (
    <DialogSlideRight
      open={open}
      handleClose={() => handleCancel()}
      handleConfirm={handleUpdateObjectives}
      title={`Kompetenzen auswählen`}
      cancelTitle="Abbrechen"
      confirmTitle="OK"
      icon={LoupeIcon}
    >
      {dataTopics ? (
        <SelectObjectivesAccordion
          groups={dataTopics}
          getGroupLabel={(group) => group.group}
          getSubData={(group) => group.topics}
        >
          {(topic, index) => <SelectingObjectivesTable key={index} topic={topic} index={index} />}
        </SelectObjectivesAccordion>
      ) : (
        <Stack sx={{ display: "flex", alignItems: "center" }}>
          <CircularProgress />
        </Stack>
      )}
    </DialogSlideRight>
  );
};

export default SelectObjectivesExamDialog;
